import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-warning',
  imports: [CommonModule, ButtonModule],
  template: `
  <div class="flex gap-2 align-items-center mb-2">
    <i class="pi pi-exclamation-circle text-red-500 text-xl"></i>
    <h4 class="p-0 m-0">{{config.data.header}}</h4>
  </div>
  <p class="white-space-normal">{{config.data.message}}</p>
  <div class="flex justify-content-end mt-4">
    <p-button pRipple label="Aceptar" icon="pi pi-check" (click)="ref.close(true)"></p-button>
  </div>
`
})
export class WarningComponent {
  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }
}
